import { useEffect, useState } from "react";
import QRCode from "qrcode";

function PaytmQrFrame({ children }) {
  return (
    <div className="customer-paytm-qr-frame">
      <div className="customer-paytm-qr-inner">{children}</div>
    </div>
  );
}

/**
 * UPI payment QR — encodes upi://pay?... for scan-from-another-phone.
 * frame="paytm" = cyan/navy split border (CW + customer payment).
 */
export default function OrderUpiQr({
  upiUrl,
  size = 200,
  alt = "Scan to pay this order",
  onTap,
  scanFriendly = false,
  frame,
}) {
  const [dataUrl, setDataUrl] = useState("");

  useEffect(() => {
    if (!upiUrl) {
      setDataUrl("");
      return undefined;
    }
    let cancelled = false;
    const usePaytmFrame = frame === "paytm";
    QRCode.toDataURL(upiUrl, {
      width: size,
      margin: usePaytmFrame ? 2 : scanFriendly ? 2 : 1,
      errorCorrectionLevel: scanFriendly ? "H" : "M",
      color: usePaytmFrame ? { dark: "#000000", light: "#FFFFFF" } : undefined,
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl("");
      });
    return () => {
      cancelled = true;
    };
  }, [upiUrl, size, scanFriendly, frame]);

  if (!upiUrl || !dataUrl) return null;

  const img = (
    <img
      src={dataUrl}
      alt={alt}
      width={frame === "paytm" ? size : undefined}
      height={frame === "paytm" ? size : undefined}
      className={frame === "paytm" ? "customer-pay-qr-img" : undefined}
      style={
        frame === "paytm"
          ? { imageRendering: "pixelated" }
          : {
              maxWidth: size,
              width: "100%",
              height: "auto",
              borderRadius: 12,
              border: "2px solid #0F766E",
              display: "block",
              margin: "0 auto",
            }
      }
      draggable={false}
    />
  );

  const qrBody = frame === "paytm" ? <PaytmQrFrame>{img}</PaytmQrFrame> : img;

  if (!onTap) return qrBody;

  return (
    <button
      type="button"
      onClick={onTap}
      aria-label={`${alt}. Tap to open Paytm on this phone.`}
      style={{
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        display: "block",
        margin: "0 auto",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      {qrBody}
    </button>
  );
}
